<template>
  <div class="content">
    <section class="activity" v-if="activityList || activityList.length">
      <van-image class="activity-title" :src="require('@/assets/huod@2x.png')"/>
      <template v-for="item of activityList">
        <div class="item" :key="item.id" @click="goToSignUp(item.id)">
          <van-image class="img" :src="item.coverImage"/>
          <div class="info">
            <h4 class="van-multi-ellipsis--l2">{{ item.title }}</h4>
            <p class="van-ellipsis" style="margin-bottom: 10px">活动时间：{{ item.activityTime }}</p>
            <p class="van-ellipsis">活动地点：{{ item.gatherSignLocation }}</p>
          </div>
        </div>
      </template>
    </section>
  </div>
</template>

<script>
import { getActivities } from '@/api/educational'

export default {
  name: 'activityRegistration2',
  data () {
    return {
      activityList: []
    }
  },
  created () {
    this.getActivities()
  },
  methods: {
    async getActivities () {
      const { result } = await getActivities()
      console.log(result)
      this.activityList = result
    },
    goToSignUp (id) {
      this.$router.push({
        path: '/educational/signup',
        query: { id }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  background-color: #F3E6DD;
  min-height: 100vh;
  overflow: hidden;
  section {
    &.activity {
      margin-top: -40px;
      //background: linear-gradient(0deg, rgba(93, 66, 37, .3), rgba(93, 66, 37, 0.3), rgba(93, 66, 37, 0.3));
      padding: 20px 20px 15px;

      .activity-title {
        width: 250px;
        display: block;
        margin: 37px auto 20px;
        margin-top: 40px;
      }

      .item {
        display: flex;
        //align-items: center;
        width: 100%;
        padding-bottom: 20px;
        border-bottom: 1px solid rgba(49, 41, 37, .2);
        .img {
          width: 120px;
          height: 100px;
          border-radius: 4px;
          overflow: hidden;
          object-fit: cover;
        }

        .info {
          flex: 1;
          overflow: hidden;
          margin-left: 10px;

          h4 {
            width: 100%;
            font-size: 16px;
            line-height: 1.3;
            color: #392F29;
            margin: 0 0 6px;
            margin-bottom: 17px;
            font-family: 'PingFangBold';
          }

          p {
            font-size: 14px;
            margin: 5px 0 0;
            font-weight: 400;
            color: #666666;

            &:nth-of-type(1) {
              margin-top: 0;
            }
          }
        }
      }
    }

    &.classroom {
      margin-left: 20px;
      margin-bottom: 30px;

      .classroom-title {
        width: 159px;
        display: block;
        margin: 24px auto 20px;
      }

      .list {
        white-space: nowrap;
        overflow-y: scroll;
        margin-bottom: 30px;
      }

      .item {
        width: 123px;
        border: 1px solid #312925;
        border-radius: 4px;
        overflow: hidden;
        display: inline-block;
        margin-right: 10px;
        background-color: #6A8D99;

        .type {
          color: #EFECEC;
          display: block;
          font-size: 12px;
          font-weight: 500;
          white-space: normal;

          span {
            display: inline-block;
            background-color: #253B41;
            line-height: 1.2;
            border-radius: 4px 0px 4px 0px;
            padding: 2px 4px;
          }
        }

        .img {
          width: 100%;
          height: 100px;
          padding: 0 10px;
          box-sizing: border-box;
          border-radius: 2px;
          overflow: hidden;
          object-fit: cover;
          white-space: normal;
        }

        .title {
          margin-top: 11px;
          line-height: 1.4;
          background: #D1D6D8;
          color: #526065;
          font-size: 14px;
          text-align: center;
          padding: 5px 0;
          white-space: normal;
        }
      }
    }

    &.review {
      padding: 20px 20px 15px;

      .review-title {
        width: 159px;
        display: block;
        margin: 0 auto 20px;
      }

      .item {
        display: flex;
        align-items: center;
        width: 100%;
        padding: 12px 0;
        //border-bottom: 1px solid rgba(49, 41, 37, .2);
        .img {
          width: 120px;
          height: 100px;
          border-radius: 4px;
          overflow: hidden;
        }

        .info {
          flex: 1;
          overflow: hidden;
          margin-left: 10px;

          h4 {
            width: 100%;
            font-size: 16px;
            line-height: 1.3;
            color: #392F29;
            margin: 0 0 18px;
            font-family: 'PingFangBold';
          }

          p {
            font-size: 12px;
            margin: 5px 0 0;
            font-weight: 400;
            color: #666666;

            &:nth-of-type(1) {
              margin-top: 0;
            }
          }
        }
      }
    }
  }
}
</style>
